import { render, staticRenderFns } from "./FileBrowserFile.vue?vue&type=template&id=56e28195&scoped=true&lang=html"
import script from "./FileBrowserFile.vue?vue&type=script&lang=js"
export * from "./FileBrowserFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e28195",
  null
  
)

export default component.exports